import React from 'react';
import PropTypes from 'prop-types';

const DesktopPlane = ({ className, color }) => (
  <svg
    className={className}
    width='27px'
    height='25px'
    viewBox='0 0 27 25'
    version='1.1'
    xmlns='http://www.w3.org/2000/svg'
    xmlnsXlink='http://www.w3.org/1999/xlink'
  >
    <g id='Page-1' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
      <g id='Desktop-2' transform='translate(-469.000000, -211.000000)' fill='#4D7CFF'>
        <path
          d='M495.079102,223.905189 L483.289628,216.655189 L483.289628,208.680189 C483.289628,207.476689 482.30226,206.505189 481.079102,206.505189 C479.855944,206.505189 478.868576,207.476689 478.868576,208.680189 L478.868576,216.655189 L467.079102,223.905189 L467.079102,226.805189 L478.868576,223.180189 L478.868576,231.155189 L475.921207,233.330189 L475.921207,235.505189 L481.079102,234.055189 L486.236997,235.505189 L486.236997,233.330189 L483.289628,231.155189 L483.289628,223.180189 L495.079102,226.805189 L495.079102,223.905189 Z'
          id='default-airplane'
          transform='translate(481.079102, 221.005189) rotate(-51.000000) translate(-481.079102, -221.005189) '
        />
      </g>
    </g>
  </svg>
);

DesktopPlane.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string,
};

export default DesktopPlane;



// WEBPACK FOOTER //
// ./src/icons/DesktopPlane.js